import { useEffect } from 'react';

export default function useSheetViewport() {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const update = () => {
      document.documentElement.style.setProperty('--sheet-viewport-height', `${viewport.height}px`);
      document.documentElement.style.setProperty(
        '--sheet-viewport-bottom',
        `${Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop)}px`,
      );
    };
    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
      document.documentElement.style.removeProperty('--sheet-viewport-height');
      document.documentElement.style.removeProperty('--sheet-viewport-bottom');
    };
  }, []);
}
